import { booleanAttribute, Component, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideNotebookText } from '@ng-icons/lucide';
import { HlmIcon } from '@spartan-ng/helm/icon';

import { Sequence } from '../../../models/séquence.model';
import { SequenceEtatComponent } from '../sequence-etat/sequence-etat.component';

@Component({
  selector: 'app-sequence-card',
  imports: [NgIcon, HlmIcon, SequenceEtatComponent],
  templateUrl: './sequence-card.component.html',
  providers: [provideIcons({ lucideNotebookText })],
})
export class SequenceCardComponent {
  readonly sequence = input.required<Sequence>();
  readonly isSelected = input<boolean, boolean | string>(false, { transform: booleanAttribute });
  readonly isExpanded = input<boolean>(true);
}
